Vendd.Scripts.load(function () {

    $('.x-control[data-control="pager"][data-type="pageSize"]').each(function (i, item) {
        var $wrapper = $(this);

        var isPagerAjax = $wrapper.data('ajax');
        var pageSizeSelectBox = $(this).find('select');

        if (isPagerAjax) {
            var connectedList = $wrapper.data('list');
            if (connectedList === undefined)
                throw 'Connected list not declared for pager ' + $wrapper.attr('id');

            var $connectedList = $('.x-control[data-control="list"][data-list="' + connectedList + '"]').first();

            pageSizeSelectBox.change(function (e) {
                var config = $connectedList.get(0).getConfiguration();

                config.LoaderData.PageSize = parseInt($(this).find(":selected").attr('value'));
                config.LoaderData.PageNumber = 1;

                $connectedList.get(0).load(config);
            });

            $connectedList.get(0).bind('dataload', function (control, response) {
                var currentConfig = $connectedList.get(0).getConfiguration();

                var pageSize = currentConfig.LoaderData.PageSize;

                var $selectBox = $wrapper.find('select');
                if ($selectBox.children('option[selected="selected"]').attr('value') !== String(pageSize)) {
                    $selectBox.children('option').removeAttr('selected');
                    $selectBox.children('option[value="' + pageSize + '"]').attr('selected', 'selected');
                }
            });
        }
        else {
            pageSizeSelectBox.change(function (e) {
                document.location = $(this).find(":selected").data('url');
            });
        }
    });

});